<template>
  <div>
    <div class="card p-3 mb-4">
      <b-row align-v="center">
        <b-col md="8">
          <div class="d-flex align-items-center mb-2">
            <h2 class="mb-0 mr-3">Proposta {{ proposta.id || 'Nova' }}</h2>
            <b-badge v-if="proposta.status == 'CANCELADO'" variant="danger" class="p-2">
              <i class="fas fa-times-circle mr-1"></i> Proposta Cancelada
            </b-badge>
          </div>
          <p class="text-muted">Preencha os dados abaixo para criar ou editar a proposta.</p>
        </b-col>

        <b-col md="4" class="text-right total-display">
          <label class="text-muted mb-0">TOTAL DA PROPOSTA BRUTO</label>
          <h1 class="text-primary font-weight-bold mb-0">
            {{ formatCurrency(showValorSubtotal) }}
          </h1>
          <h6 v-if="proposta.tipo_bonificacao == 'BRINDE'" class="text-danger mt-1">
            Saldo Bruto Brinde: {{ formatCurrency(getSaldoBrindeBruto) }} / Saldo Liquido Brinde: {{formatCurrency(getSaldoBrinde)}}
          </h6>
        </b-col>
      </b-row>
    </div>

    <b-card no-body class="mb-4">
      <b-card-header header-tag="header">
        <h5 class="mb-0"><i class="fas fa-file-alt mr-2"></i>Informações Gerais</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group label="Tipo da Proposta" label-for="tipo-proposta">
              <b-form-select id="tipo-proposta" @change="changePrazoPagamento" v-model="proposta.tipo_proposta"
                :options="getListaTipoProposta"
                :disabled="role == 'preposto' || readonly || proposta.id != null"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="8">
            <b-form-group label="Selecione um Cliente / Lead" label-for="select-cliente">
              <v-select id="select-cliente" v-model="prospecto" :options="listaProspecto" @search="buscaLead"
                @change="selectProspecto" :disabled="readonly || proposta.id != null"
                placeholder="Digite para buscar..."></v-select>
            </b-form-group>
          </b-col>
          <b-col v-if="proposta.tipo_proposta == 'BONIFICACAO'" cols="12" md="4">
            <b-form-group label="Classificação da Bonificação" label-for="classificacao-bonificacao"
              :description="showAprovarButton ? 'Revise a classificação antes de aprovar.' : ''">
              <b-form-select id="classificacao-bonificacao" v-model="proposta.classificacao_bonificacao"
                :options="optionsClassificacaoBonificacao" :disabled="readonly"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <fieldset :disabled="!prospecto || readonly">
      <b-card no-body class="mb-4">
        <b-card-header header-tag="header">
          <h5 class="mb-0"><i class="fas fa-dollar-sign mr-2"></i>Condições Comerciais</h5>
        </b-card-header>
        <b-card-body>
          <b-row>

            <b-col v-if="proposta.tipo_proposta == 'VENDA' || proposta.tipo_proposta == 'BONIFICACAO'" md="6" lg="4">
              <b-form-group label="Desconto (%)">
                <b-form-select :disabled="readonly" v-model="proposta.desconto"
                  @change="processarPromotions(), removeBrindes()">
                  <option v-for="option in optionsDescontos" :key="option.value" :value="option.value" :disabled="option.disabled">
                    {{ option.text }}
                    <span v-if="option.disabled" class="text-muted">({{ option.text_disabled }})</span>
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col v-if="proposta.tipo_proposta == 'VENDA' && canBonif && getClassProspecto != 'F'" md="6" lg="4">
              <b-form-group label="Bonificação (%)">
                <b-form-select :disabled="readonly" class="form-control" v-model="proposta.bonificacao"
                  @change="removeBrindes()">
                  <option value="0">Sem Bonificação</option>
                  <option value="5">5 %</option>
                  <option value="10">10 %</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            
            <b-col md="12" v-if="proposta && proposta.bonificacao > 0" class="mt-2 mb-3">
              <b-form-group label="Tipo de Bonificação">
                <b-form-radio-group v-if="!readonly" :disabled="readonly" v-model="proposta.tipo_bonificacao"
                  :options="optionsTipo" buttons button-variant="outline-primary" size="sm"
                  @change="removeBrindes()"></b-form-radio-group>
                <b-badge v-else variant="primary">{{ proposta.tipo_bonificacao }}</b-badge>
              </b-form-group>
            </b-col>

            <b-col v-if="proposta.tipo_proposta == 'VENDA'" md="6" lg="4">
              <b-form-group label="Prazo Pagamento" class="prazo-medio" :invalid-feedback="getPrazoMedio"
                :state="false">
                <b-form-select v-model="proposta.prazo_pagamento" :disabled="readonly"
                  :options="proposta.tipo_proposta == 'BONIFICACAO' || proposta.tipo_proposta == 'AMOSTRA' ? showPrazosPagamento : proposta.id && proposta.id <= 357 ? showPrazosPagamento : optionsPrazo">
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col v-if="proposta.tipo_proposta == 'VENDA'" md="6" lg="4">
              <b-form-group label="Vencimento da Proposta">
                <b-form-input :disabled="readonly" v-model="proposta.vencimento_proposta" type="date" />
              </b-form-group>
            </b-col>

            <b-col v-if="proposta.tipo_proposta == 'VENDA'" md="6" lg="4">
              <b-form-group label="Ordem de Compra (Opcional)">
                <b-form-input v-model="proposta.ordem_compra" :disabled="readonly"
                  v-mask="['####################']"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="12" class="mt-2">
              <b-form-group label="Observações da Proposta">
                <b-form-textarea v-model="proposta.obs" :disabled="readonly"
                  placeholder="Digite aqui alguma observação importante..." rows="4" no-resize></b-form-textarea>
              </b-form-group>
            </b-col>

          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-4">
        <b-card-header header-tag="header">
          <h5 class="mb-0"><i class="fas fa-box mr-2"></i>Itens da Proposta</h5>
        </b-card-header>
        <b-card-body>
          <busca-produto class="mb-2" v-if="!readonly" title="Adicionar produto à proposta"
            :listaProdutos="listaProdutos" :item="item" :brinde="proposta.tipo_bonificacao == 'BRINDE' ? true : false"
            @addProduto="addProduto" />

          <div class="text-right mb-4" v-if="!readonly">
            <b-button variant="outline-primary" size="sm" @click="modalImportarPlanilha = true">
              <i class="fas fa-file-excel mr-1"></i> Importar Planilha
            </b-button>
          </div>

          <b-table :key="itensTableKey" :items="itens" :fields="headerItens" striped small hover foot-clone responsive show-empty
            empty-text="Nenhum item adicionado à proposta.">
            <template #cell(produto_id)="data">
              <b-button v-if="!readonly" @click="removeItem(data.index)" :disabled="data.item.promocao && data.item.promocao.bloquear" variant="outline-danger" size="sm"
                v-b-tooltip.hover title="Remover Item">
                <i class="fas fa-trash"></i>
              </b-button>
            </template>
            <template #cell(produto)="data">
              <div>
                <strong>{{ data.item.produto.codigo }}</strong> - {{ data.item.produto.descricao }}
                <div v-if="data.item.promocao" class="mt-1">
                  <b-badge variant="success">
                    <i class="fas fa-tags mr-1"></i> {{ data.item.promocao.descricao }}
                  </b-badge>
                </div>
              </div>
            </template>
            <template #cell(valor_unitario)="row">
              <div
                v-if="row.item.produto.preco_regular && row.item.produto.preco_regular > 0 && row.item.produto.preco_venda < row.item.produto.preco_regular">
                <small class="text-danger" style="text-decoration: line-through;">
                  {{ formatCurrency(parseFloat(row.item.produto.preco_regular)) }}
                </small>
              </div>
              {{ formatCurrency(parseFloat(row.item.valor_unitario)) }}
              <div v-if="row.item.valor_unitario_tabela && parseFloat(row.item.valor_unitario) > parseFloat(row.item.valor_unitario_tabela)">
                <small class="text-success">
                  Tabela: {{ formatCurrency(parseFloat(row.item.valor_unitario_tabela)) }}
                </small>
              </div>
            </template>
            <template #foot(produto_id)></template>
            <template #foot(produto)></template>
            <template #foot(quantidade)><strong class="text-right">TOTAIS</strong></template>
            <template #foot(valor_unitario)><strong>{{ formatCurrency(totalAmountUnit) }}</strong></template>
            <template #foot(valor_desconto)><strong>{{ formatCurrency(totalAmountDesconto) }}</strong></template>
            <template #foot(valor_total)><strong>{{ formatCurrency(totalAmount) }}</strong></template>
          </b-table>
        </b-card-body>
      </b-card>
    </fieldset>

    <b-card no-body>
      <b-card-header>
        <h5 class="mb-0"><i class="fas fa-tasks mr-2"></i>Resumo e Ações</h5>
      </b-card-header>
      <b-card-body>
        <b-row align-v="center">
          <b-col md="6">
            <div class="list-group">
              <div class="list-group-item d-flex justify-content-between align-items-center">
                Valor Bruto
                <span class="font-weight-bold">{{ formatCurrency(showValorSubtotal) }}</span>
              </div>
              <div class="list-group-item d-flex justify-content-between align-items-center">
                Valor Desconto
                <span class="font-weight-bold text-danger">- {{ formatCurrency(showValorDesconto) }}</span>
              </div>
              <div class="list-group-item active d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-white">Valor Líquido</h5>
                <h5 class="mb-0 font-weight-bold text-white">{{ formatCurrency(showValorTotalComDesconto) }}</h5>
              </div>
            </div>
          </b-col>
          <b-col md="6" class="text-right">
            <b-button variant="light" @click="imprimir" v-if="proposta && parseInt(proposta.id) > 0" class="mr-2">
              <i class="fa fa-print"></i> Imprimir
            </b-button>
            <b-button variant="secondary" href="/venda-direta/propostas">
              <i class="fas fa-arrow-left"></i> Voltar
            </b-button>
            <hr>
            <b-button variant="warning" class="ml-2" @click="aprovarProposta" v-if="showAprovarButton">
              <i class="fas fa-check"></i> Aprovar Proposta
            </b-button>
            <b-button variant="primary" class="ml-2" @click="saveProposta" v-if="proposta.status === 'ABERTO'">
              <i class="fas fa-save"></i> Salvar Proposta
            </b-button>
            <b-button variant="success" class="ml-2" @click="GerarPedido" v-if="validationGerarPedido"
              :disabled="pedido_gerado">
              <i class="fas fa-box-open"></i> Gerar Pedido
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-modal title="Copia e Cola" v-model="modalCopiaCola" size="lg">
      </b-modal>

    <b-modal title="Importar Planilha" v-model="modalImportarPlanilha" size="lg" @hidden="resetImportarPlanilha">
      <p>
        Envie uma planilha (XLS, XLSX ou CSV) com as colunas <strong>Produto</strong>, <strong>Quantidade</strong>
        (ou "Qtd") e, opcionalmente, <strong>Preço</strong>. O nome das colunas não diferencia maiúsculas/minúsculas.
      </p>
      <p class="text-muted small">
        A coluna Produto deve conter o código do produto. Se a coluna Preço não for informada (ou vier vazia em
        alguma linha), será usado o preço de tabela. Um preço abaixo do valor de tabela será rejeitado.
      </p>
      <b-form-file v-model="arquivoImportacao" accept=".xlsx,.xls,.csv" placeholder="Escolha um arquivo..."
        drop-placeholder="Solte o arquivo aqui..." />

      <div v-if="importacaoResultado" class="mt-3">
        <b-alert show variant="success" v-if="importacaoResultado.sucesso.length > 0">
          {{ importacaoResultado.sucesso.length }} produto(s) importado(s) com sucesso.
        </b-alert>
        <b-alert show variant="warning" v-if="importacaoResultado.erros.length > 0">
          <strong>{{ importacaoResultado.erros.length }} linha(s) com problema:</strong>
          <ul class="mb-0">
            <li v-for="(erro, index) in importacaoResultado.erros" :key="index">{{ erro }}</li>
          </ul>
        </b-alert>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" @click="modalImportarPlanilha = false">Fechar</b-button>
        <b-button variant="primary" :disabled="!arquivoImportacao || loadingImportacao" @click="importarPlanilha">
          <b-spinner small v-if="loadingImportacao" /> Importar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import buscaProduto from "../produtos/busca-produto.vue";
import CardDesconto from "./card-desconto.vue";
export default {
  components: { buscaProduto, CardDesconto },
  name: "create-proposta",
  props: {
    id_proposta: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      loadingEstoque: false,
      role: "",
      listaTipoProposta: [],
      optionsPrazo: [],
      hasCont100: false,
      hasCond90: false,      
      clientes: [],
      itens: [],
      prospectos: [],
      listaProdutos: [],
      prospecto: "",
      pedido_gerado: false,
      perfil: "",
      readonly: false,
      copiaCola: "",
      item: {
        id: null,
        produto: {
          id: null,
          descricao: "",
          preco_venda: 0,
        },
        produto_id: null,
        quantidade: 1,
        valor_unitario: 0.0,
        valor_total: 0.0,
      },
      proposta: {
        id: null,
        classe: "",
        prospecto: "",
        tipo_proposta: "VENDA",
        tipo: "VAREJO",
        prospecto_id: null,
        enviado_email: false,
        grupo_desconto: "A",
        status: "ABERTO",
        pagamento: "",
        valor_desconto: 0,
        valor: 0,
        obs: "",
        vencimento_proposta: moment().add(10, "days").format("YYYY-MM-DD"),
        prazo_pagamento: null,
        prazo_pagamento_id: "",
        itens: [],
        bonificacao: "0",
        tipo_bonificacao: null,
        classificacao_bonificacao: null,
        desconto: '0',
      },
      optionsTipo: [
        { text: "Brinde", value: "BRINDE" },
        { text: "Desconto", value: "DESCONTO" },
      ],
      optionsClassificacaoBonificacao: [
        { value: null, text: "Selecione uma classificação", disabled: true },
        { value: "PLANO_INTRODUCAO_REDES", text: "Plano de Introdução Redes" },
        { value: "OUTROS", text: "Outros" },
      ],
      modalCopiaCola: false,
      modalImportarPlanilha: false,
      arquivoImportacao: null,
      loadingImportacao: false,
      importacaoResultado: null,
      descontos: [],
      itensBackup: [],
      itensTableKey: 0,
    };
  },
  computed: {
    getClassProspecto(){
      const classe = this.prospecto?.value?.classe_distribuidor?.replace(/\s+/g, '')
      return classe
    },
    canBonif(){
      return true
      /*
      const cod = this.prospecto?.value?.distribuidor
        ? this.prospecto.value.distribuidor.codigo
        : null;
      if (
        cod &&
        (cod == "0687002" ||
          cod == "0692956" ||
          cod == "0687108" ||
          cod == "0663609")
      ) {
        return true;
      } else {
        this.proposta.bonificacao =0
        return false;
      }      
      */
    },
    optionsDescontos(){
      var data = []
      const classe = this.getClassProspecto

      if(classe == 'F'){
        data = [
          {
            value: "0",
            text: "0 %",
            disabled: false
          },
          {
            value: "13.00",
            text: "13 %",
            disabled: this.showValorTotal < 3000,
            text_disabled: "Requer valor mínimo de R$ 3.000,00"
          },
          // {
          //   value: "24.00",
          //   text: "24 %",
          //   disabled: this.showValorTotal < 3000,
          //   text_disabled: "Requer valor mínimo de R$ 3.000,00"
          // }
        ]
      }else{
        data = [
          {
            value: "0",
            text: "0 %",
            disabled: false
          },
          {
            value: "10.00",
            text: "10 %",
            disabled: false
          },
          {
            value: "20.00",
            text: "20 %",
            disabled: false
          },
          {
            value: "30.00",
            text: "30 %",
            disabled: false
          },
          {
            value: "40.00",
            text: "40 %",
            disabled: false
          },
          {
            value: "50.00",
            text: "50 %",
            disabled: false
          },
        ]
      }

      return data
    },
    showAprovarButton() {
        return (
            this.proposta.status === 'ABERTO' &&
            ['BONIFICACAO', 'REQUISICAO', 'AMOSTRA_DISTRIBUIDOR', 'AMOSTRA'].includes(this.proposta.tipo_proposta) &&
            this.permissao &&
            !this.proposta.aprovado &&
            this.proposta.id
        );
    },
    getSaldoBrinde() {
      const value = this.showValorTotalBrinde;
      return (value <= 0 && value >= -100) ? 0 : value;
    },
    getSaldoBrindeBruto() {
      const value = this.showValorTotalBrindeBruto;
      return (value <= 0 && value >= -100) ? 0 : value;
    },
    totalAmountUnit() {
      return this.itens.reduce((acc, item) => {
        return acc + parseFloat(item.valor_unitario) * item.quantidade;
      }, 0);
    },
    totalAmountDesconto() {
      return this.itens.reduce((acc, item) => {
        const totalItem = parseFloat(item.valor_total || 0);

        return acc + totalItem;
      }, 0);
    },

    totalAmount() {
      return this.itens.reduce((acc, item) => {
        if (
          this.proposta.tipo_proposta === "BONIFICACAO" ||
          this.proposta.tipo_proposta === "REQUISICAO" ||
          this.proposta.tipo_proposta === "AMOSTRA_DISTRIBUIDOR" ||
          this.proposta.tipo_proposta === "AMOSTRA"
        ) {
          return acc + 0; // O total líquido é 0 para esses tipos
        }else{
          return acc + parseFloat(item.valor_total)
        }
      }, 0);
    },
    getValorBruto() {
      return this.showValorTotal;
    },
    showValorTotalComDesconto() {
      return this.showValorTotal - this.showValorDesconto
    },
    getListaTipoProposta() {
      let lista = [];
      if (this.role == 'Preposto') {
        lista = [
          {
            value: "VENDA",
            text: "VENDA"
          }
        ]
      } else if (this.role == 'Marketing') {
        lista = [
          {
            value: "AMOSTRA",
            text: "AMOSTRA",
          },
          {
            value: "AMOSTRA_DISTRIBUIDOR",
            text: "AMOSTRA DISTRIBUIDOR",
          }
        ]
      } else if (this.role) {
        lista = [
           {
             value: "BONIFICACAO",
             text: "BONIFICAÇÂO",
           },
          {
            value: "AMOSTRA",
            text: "AMOSTRA",
          },
          {
            value: "AMOSTRA_DISTRIBUIDOR",
            text: "AMOSTRA DISTRIBUIDOR",
          },
          {
            value: "VENDA",
            text: "VENDA",
          },
          {
            value: "REQUISICAO",
            text: "REQUISIÇÃO",
          }
        ]
      }
      return lista;
    },
    hasBrinde() {
      let val = false
      this.itens.forEach((el) => {
        if (el.brinde) {
          val = true
        }
      })
      return val
    },
    getPrazoMedio() {
      if (
        !this.proposta.prazo_pagamento ||
        this.proposta.prazo_pagamento == ""
      ) {
        return "";
      }
      let selecionado = this.optionsPrazo.find(
        (el) => this.proposta.prazo_pagamento == el.value
      );
      if (selecionado && selecionado.value != 5) {
        let prazo = selecionado.media
          ? "Prazo Médio: " + selecionado.media + " Dias"
          : "";
        return prazo;
      }
    },
    validationGerarPedido() {
      const distribuidor = this.proposta.prospecto
        ? this.proposta.prospecto.distribuidor
          ? this.proposta.prospecto.distribuidor.id
          : null
        : this.proposta.distribuidor
          ? this.proposta.distribuidor.id
          : null;
      if (
        this.role !== "Preposto" &&
        this.proposta.status === "ABERTO" &&
        this.proposta.id &&
        distribuidor &&
        (this.proposta.tipo_proposta == "VENDA" ||
          ((this.proposta.tipo_proposta == "BONIFICACAO" ||
            this.proposta.tipo_proposta == "REQUISICAO" ||
            this.proposta.tipo_proposta == "AMOSTRA_DISTRIBUIDOR" ||
            this.proposta.tipo_proposta == "AMOSTRA") &&
            this.proposta.aprovado &&
            this.perfil.roles[0].label == "Administrador"))
      ) {
        return true;
      } else {
        return false;
      }
    },
    permissao() {
      if (
        this.perfil.roles[0].pivot.user_id == 7507 ||
        this.perfil.roles[0].pivot.user_id == 5929 ||
        this.perfil.roles[0].pivot.user_id == 17652 ||
        this.perfil.roles[0].label == "Administrador"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showPrazosPagamento() {
      let data = [];
      if (this.prospecto) {
        data = [
          {
            value: "5",
            text: "A Vista",
          },
          {
            value: "1",
            text: "Consignado",
          },
          {
            value: "30",
            text: "30 Dias ",
          },
          {
            value: "20",
            text: "20/30/40 Dias",
          },
          {
            value: "35",
            text: "35/50/65 Dias",
          },
          {
            value: "40",
            text: "40/50 Dias",
          },
          {
            value: "60",
            text: "30/45/60 Dias",
          },
          {
            value: "70",
            text: "60 Dias",
          },
        ];

        if (this.hasCond90) {
          data.push({ value: "90", text: "30/60/90 Dias" });
        }
        if (this.hasCont100) {
          data.push({ value: "78", text: "80/90/100 Dias" });
        }
        //console.log(this.prospecto.value);
        if (
          this.prospecto.value &&
          (this.prospecto.value.prospecto_empresa.endereco.cidade.estado.uf ==
            "AM" ||
            this.prospecto.value.prospecto_empresa.endereco.cidade.estado.uf ==
            "RO")
        ) {
          data.push({ value: "75", text: "75 Dias" });
          data.push({ value: "76", text: "65/75/85 Dias" });
        }
      }
      return data;
    },
    headerItens() {
      if (this.proposta.tipo_bonificacao == "BRINDE") {
        return [
          { key: "produto_id", label: "#" },
          {
            key: "produto",
            label: "Produto",
            formatter: (value) => {
              return value.codigo + " - " + value.descricao;
            },
          },
          { key: "quantidade", label: "Quantidade", class: "text-center" },
          {
            key: "brinde",
            label: "Brinde",
            class: "text-center",
            formatter: (value) => {
              return value ? "Sim" : "Não";
            },
          },
          {
            key: "valor_unitario",
            label: "Unit. Preço",
            class: "text-center",
          },
          {
            key: "valor_desconto",
            label: "Unit. Preço C/ Desc",
            class: "text-center",
            formatter: (value, key, item) => {
              const totalItem = parseFloat(item.valor_total || 0);
              const quantidade = parseFloat(item.quantidade) || 1;
              const valorUnitarioComDesconto = totalItem / quantidade;

              return (
                "R$ " +
                valorUnitarioComDesconto
                .toFixed(2)
                .toString()
                .replace(".", ",")
              );
            },
          },
          {
            key: "valor_total",
            label: "Valor Total",
            class: "text-center",
            formatter: (value, key, item) => {
              return (
                "R$ " +
                (item.brinde
                  ? "0,00"
                  : parseFloat(value).toFixed(2).toString().replace(".", ","))
              );
            },
          },
        ];
      } else {
        return [
          { key: "produto_id", label: "#" },
          {
            key: "produto",
            label: "Produto",
            formatter: (value) => {
              return value.codigo + " - " + value.descricao;
            },
          },
          { key: "quantidade", label: "Quantidade", class: "text-center" },
          {
            key: "valor_unitario",
            label: "Unit. Preço",
            class: "text-center"
          },
          {
            key: "valor_desconto",
            label: "Unit. Preço C/ Desc",
            class: "text-center",
            formatter: (value, key, item) => {
              const totalItem = parseFloat(item.valor_total || 0);
              const quantidade = parseFloat(item.quantidade) || 1;
              const valorUnitarioComDesconto = totalItem / quantidade;

              return (
                "R$ " +
                valorUnitarioComDesconto
                .toFixed(2)
                .toString()
                .replace(".", ",")
              );
            },
          },
          {
            key: "valor_total",
            label: "Valor Total",
            class: "text-center",
            formatter: (value) => {
              if (
                this.proposta.tipo_proposta == "BONIFICACAO" ||
                this.proposta.tipo_proposta == "REQUISICAO" ||
                this.proposta.tipo_proposta == "AMOSTRA_DISTRIBUIDOR" ||
                this.proposta.tipo_proposta == "AMOSTRA"
              ) {
                return "R$ 0,00";
              } else {
                return (
                  "R$ " +
                  parseFloat(value).toFixed(2).toString().replace(".", ",")
                );
              }
            },
          },
        ];
      }
    },
    showFaixa() {
      let faixa = {
        id: null,
        quantidade_minima: 0,
        quantidade_maxima: 0,
        valor: 0,
      };
      const vm = this;
      let total = vm.showValorSubtotal;
      if (vm.descontos.length > 0) {
        let _faixa = vm.descontos.find((ds) => {
          return total > ds.quantidade_minima && total <= ds.quantidade_maxima;
        });
        if (_faixa) {
          faixa = _faixa;
        }
      }
      return faixa;
    },

    listaProspecto() {
      var _prospectos = [];
      if (this.prospectos.length > 0) {
        this.prospectos.map((el) => {
          _prospectos.push({
            label:
              el.distribuidor && el.distribuidor.codigo ? el.prospecto_empresa.pessoa_juridica.cnpj + " - " + el.distribuidor.codigo + " - " + el.prospecto_empresa.pessoa_juridica.razao_social
                : el.classe == "K" ? el.id + " - " + el.nome
                  : el.prospecto_empresa.pessoa_juridica.cnpj + " - " + el.prospecto_empresa.pessoa_juridica.razao_social, value: el,
          });
        });
      }
      return _prospectos;
    },

    showValorSubtotal() {
      let total = 0;
      this.itens.map((el) => {
        if (!el.brinde) {
          total += parseFloat(el.valor_unitario) * el.quantidade;
        }
      });
      return parseFloat(total);
    },
    showValorTotal() {
      return (
        parseFloat(this.showValorSubtotal) // - parseFloat(this.showValorDesconto)
      );
    },
    showValorTotalBrinde() {
      const vm = this;
      if (this.proposta.tipo_bonificacao == "BRINDE") {
        let totalBrinde = 0;
        totalBrinde = (vm.showValorTotal - parseFloat(this.showValorDesconto)) * (vm.proposta.bonificacao / 100);
        vm.itens.map((el) => {
          if (el.brinde) {
            totalBrinde -= parseFloat(
              (el.valor_unitario -
                el.valor_unitario * (vm.proposta.desconto / 100)) *
              el.quantidade
            );
          }
        });
        return parseFloat(totalBrinde);
      } else {
        return 0;
      }
    },
    showValorTotalBrindeBruto() {
      const vm = this;
      if (this.proposta.tipo_bonificacao == "BRINDE") {
        let totalBrinde = 0;
        totalBrinde = vm.showValorTotal * (vm.proposta.bonificacao / 100);
        vm.itens.map((el) => {
          if (el.brinde && !el.promocao) {
            totalBrinde -= parseFloat(
              (el.valor_unitario -
                el.valor_unitario * (vm.proposta.desconto / 100)) *
              el.quantidade
            );
          }
        });
        return parseFloat(totalBrinde);
      } else {
        return 0;
      }
    },
    showValorDesconto() {
      let total = 0;
      this.itens.map((el) => {
        if (!el.brinde) {
          if (
            this.proposta.tipo_proposta == "BONIFICACAO" ||
            this.proposta.tipo_proposta == "REQUISICAO" ||
            this.proposta.tipo_proposta == "AMOSTRA" ||
            this.proposta.tipo_proposta == "AMOSTRA_DISTRIBUIDOR"
          ) {
            total += parseFloat(el.valor_unitario * el.quantidade);
          } else {
            total += parseFloat(el.valor_desconto);
          }
        }
      });
      return total;
    },
  },

  methods: {
    async changePrazoPagamento() {
      this.prospecto = "";
      this.prospectos = [];

      if (this.proposta.tipo_proposta == "BONIFICACAO" || this.proposta.tipo_proposta == "REQUISICAO") {
        this.proposta.prazo_pagamento = 5;
        if (this.itensBackup.length > 0) {
          this.itens = this.itensBackup;
        }
        await this.getProdutos(this.proposta.tipo_proposta);
      } else if (this.proposta.tipo_proposta == "AMOSTRA") {
        this.itensBackup = this.itens;
        this.itens = [];
        this.proposta.prazo_pagamento = 5;
        await this.getProdutos(this.proposta.tipo_proposta);
      } else {
        if (this.itensBackup.length > 0) {
          this.itens = this.itensBackup;
        }
        await this.getProdutos(this.proposta.tipo_proposta);
      }
    },
    async processarPromotions(){
      const vm = this;

      await this.calculaDesconto();
      $(".loading").show();

      try{
        const response = await axios
          .post("/venda-direta/promotions/processar", {
            desconto: vm.proposta.desconto,
            tipo_proposta: vm.proposta.tipo_proposta,
            itens: vm.itens
          })
        
        if(response.data && response.data.itens) {
          vm.itens = response.data.itens.map((item) => ({
            ...item,
            produto: item.produto ? { ...item.produto } : item.produto,
          }));
          vm.itensTableKey += 1;
        }

        console.log(response.data);
      }catch(error){
        console.log("Erro ao processar promotions", error);
      }

      $(".loading").hide();

    },
    aprovarProposta() {
      if (this.proposta.tipo_proposta == "BONIFICACAO" && !this.proposta.classificacao_bonificacao) {
        return this.$swal("Atenção", "Informe a classificação da bonificação!", "error");
      }
      axios
        .post("/venda-direta/proposta/aprovar", {
          perfil: this.perfil,
          proposta: this.proposta.id,
          classificacao_bonificacao: this.proposta.classificacao_bonificacao,
        })
        .then((response) => {
          this.$swal(response.data.msg, "", "success");
          window.location.href = "/venda-direta/propostas";
          // this.loadProposta();
        })
        .catch((error) => {
          this.$swal(error.response ? error.response.data.error : `${error}`, "", "warning");
          this.loadProposta();
        });
    },
    removeBrindes() {
      if (this.proposta.bonificacao == 0) {
        this.proposta.tipo_bonificacao = null;
      }
      let items = this.itens.filter((el) => !el.brinde);
      this.itens = items;
    },
    removeItem(index) {
      this.itens.splice(index, 1);
      this.processarPromotions();
    },
    async calculaDesconto() {
      const vm = this;
      return await new Promise((resolve) => {
        let desconto = this.showFaixa;
        let valor = 0;
        let valor_desconto = 0;
        let prospid = this.proposta.prospecto_id;
        let valor_desconto_str = 0;
        if (vm.proposta.desconto || !vm.proposta.id) {
          this.itens.map((it) => {
            valor = parseFloat(it.valor_unitario * it.quantidade);
            valor_desconto = parseFloat(
              valor * parseFloat(vm.proposta.desconto / 100)
            );
            it.valor_desconto = valor_desconto;
            it.valor_total = valor - valor_desconto;
          });
        } else if (desconto.valor > 0) {
          this.itens.map((it) => {
            valor = parseFloat(it.valor_unitario * it.quantidade);
            valor_desconto = parseFloat(
              valor * parseFloat(desconto.valor / 100)
            );
            it.valor_desconto = valor_desconto;
            it.valor_total = valor - valor_desconto
          });
        }

        resolve(true);
      });
    },
    getFaixaDescontos() {
      const vm = this;
      var grupo_desconto = vm.proposta.prospecto
        ? vm.proposta.prospecto.distribuidor
          ? vm.proposta.prospecto.distribuidor.grupo_desconto_varejo
          : vm.proposta.prospecto.grupo_desconto_varejo
            ? vm.proposta.prospecto.grupo_desconto_varejo
            : vm.proposta.grupo_desconto
              ? vm.proposta.grupo_desconto
              : "A"
        : "A"; //padrão
      axios
        .get("/venda-direta/descontos/listar", {
          params: { grupo_desconto: grupo_desconto },
        })
        .then((resp) => {
          vm.descontos = resp.data;
        });
    },
    GerarPedido() {
      const vm = this;
      vm.$swal
        .fire({
          title: "Realmente deseja gerar o pedido desta proposta ?",
          text: "Ao gerar o pedido, o mesmo será aprovado e não poderá ser alterado",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim Enviar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .post("/venda-direta/proposta/" + vm.proposta.id + "/aprovar", {})
              .then(function (response) {
                $(".loading").hide();
                window.location.href = "/venda-direta/pedidos";
              })
              .catch(function (error) {
                $(".loading").hide();
                var e = error.response.data.errors;
                vm.$swal("Ok", error.response ? e : `${error}`, "error");
              });
          }
        });
    },
    saveProposta() {
      const vm = this;
      if (!vm.proposta.prazo_pagamento && vm.proposta.tipo_proposta == "VENDA") {
        return vm.$swal(
          "Informe o prazo de pagamento",
          "Para prosseguir com a proposta, Selecione um prazo de pagamento válido",
          "error"
        );
      }

      if (vm.proposta.tipo_proposta == "BONIFICACAO" && !vm.proposta.classificacao_bonificacao) {
        return vm.$swal(
          "Informe a classificação da bonificação",
          "Para prosseguir com a proposta, selecione uma classificação para a bonificação",
          "error"
        );
      }

      if (!vm.proposta.prospecto_id && vm.proposta.classe != "K") {
        return vm.$swal(
          "Informe um cadastro",
          "Para prosseguir com a proposta, selecione um cadastro válido",
          "error"
        );
      }

      if (vm.itens.length <= 0) {
        return vm.$swal(
          "Informe ao menos um item",
          "Para prosseguir selecione um produto, informe a quantidade e clique em adicionar.",
          "error"
        );
      }

      if(vm.proposta.desconto == '13.00' && vm.showValorTotal < 3000 && vm.proposta.tipo_proposta == "VENDA"){
        return vm.$swal(
          "Atenção",
          "Para aplicar 13% de desconto, o valor total da proposta deve ser igual ou superior a R$ 3.000,00! ",
          "error"
        );
      }else if(vm.showValorTotal < 1000 && vm.proposta.tipo_proposta == "VENDA"){
        return vm.$swal(
          "Atenção",
          "Para finalizar proposta sem desconto, o valor total da proposta deve ser igual ou superior a R$ 1.000,00! ",
          "error"
        );
      }

      // if(vm.proposta.desconto == '24.00' && vm.showValorTotal < 3000){
      //   return vm.$swal(
      //     "Atenção",
      //     "Para aplicar 24% de desconto, o valor total da proposta deve ser igual ou superior a R$ 3.000,00! ",
      //     "error"
      //   );
      // }

      if (
        vm.proposta.tipo_bonificacao == "BRINDE" &&
        vm.showValorTotalBrinde + 100 < 0
      ) {
        return vm.$swal(
          "Atenção",
          "O saldo brinde deve ser maior ou igual a zero! ",
          "error"
        );
      }
      if (this.proposta.bonificacao && this.proposta.tipo_bonificacao == "BRINDE" && !this.hasBrinde) {
        return vm.$swal(
          "Atenção",
          "Nenhum brinde adicionado!",
          "error"
        );
      }
      if (this.proposta.bonificacao > 0 && !this.proposta.tipo_bonificacao) {
        return vm.$swal(
          "Atenção",
          "Informe o tipo de bonificação!",
          "error"
        );
      }

      $(".loading").show();
      vm.proposta.tipo_bonificacao =
        vm.proposta.bonificacao == "0" ? null : vm.proposta.tipo_bonificacao;
      if (this.proposta.id && !this.proposta.desconto) {
        this.proposta.desconto = this.showFaixa.valor;
      }
      this.proposta.valor_desconto = this.showValorDesconto;
      this.proposta.valor = this.showValorTotalComDesconto; // this.showValorTotal;
      this.proposta.itens = this.itens;
      this.proposta.valor_bruto = this.getValorBruto;
      axios
        .post("/venda-direta/proposta", this.proposta)
        .then((response) => {
          this.$emit("id_proposta", response.data.proposta.id);
          vm.proposta = response.data.proposta;
          vm.$swal.fire({ title: "Proposta salva com sucesso!",
          icon: "success",
          timer: 2500,
          showConfirmButton: false,
        })
        /* vm.loadProposta(); */
            .then(() => {
              window.location.href = "/venda-direta/propostas";
            });
        })
        .catch((error) => {
          console.log(error);
          if (typeof (error.response.data) == 'string') {
            vm.$swal(
              "Atenção",
              error.response.data,
              "error"
            );
          } else {
            vm.$swal(
              "Desculpe",
              "Houve um erro inesperado ao salvar sua proposta.",
              "error"
            );
          }
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
    loadProposta() {
      return new Promise((resolve) => {
        if (parseInt(this.id_proposta) > 0) {
          const vm = this;
          $(".loading").show();
          axios
            .get("/venda-direta/proposta/" + vm.id_proposta)
            .then((response) => {
              vm.proposta = response.data;
              vm.prospecto = {
                value: response.data.prospecto
                  ? response.data.prospecto
                  : response.data.distribuidor,
                label: response.data.prospecto
                  ? response.data.prospecto.prospecto_empresa.pessoa_juridica
                    .razao_social
                  : response.data.distribuidor.codigo +
                  " - " +
                  response.data.distribuidor.nome,
              };
              if (vm.proposta.tipo_proposta == "VENDA") {
                vm.proposta.prazo_pagamento = vm.proposta.prazo_pagamento
                  ? vm.proposta.prazo_pagamento
                  : vm.prospecto.value.prazo_pagamento;
              } else {
                vm.proposta.prazo_pagamento = null;
              }
              vm.readonly = vm.proposta.status !== "APROVADO" ? false : true;
              vm.itens = response.data.itens;
              if (vm.proposta && vm.proposta.id) {
                this.getProdutos(vm.proposta.tipo_proposta);
              }
              this.getFaixaDescontos();
              this.processarPromotions();
              $(".loading").hide();
              resolve("Busca feita com sucesso!");
            })
            .catch((error) => {
              $(".loading").hide();
              console.log(error, "erro ao buscar proposta.");
              this.getFaixaDescontos();
              resolve("erro ao buscar proposta.");
            });
        }

        resolve();
      });
    },
    selectProspecto(obj) {
      if (typeof obj === "undefined" || typeof obj === "string" || !obj) {
        return;
      }
      const vm = this;
      const selected = obj.value;

      vm.proposta.desconto = 0;

      if (selected.classe == "K") {
        vm.proposta.prospecto_id = null;
        vm.proposta.classe = selected.classe;
        vm.proposta.distribuidor_id = selected.id;
        vm.proposta.prazo_pagamento = 5;
        vm.proposta.pagamento = "BOLETO";
      } else {
        vm.proposta.prospecto_id = selected.id;
        vm.proposta.pagamento = selected.pagamento;
      }

      if (vm.proposta.tipo_proposta == "VENDA") {
        if (vm.proposta.id && vm.proposta.id <= 357) {
          vm.proposta.prazo_pagamento = vm.proposta.id
            ? vm.proposta.prazo_pagamento_id
            : selected.prazo_pagamento;
        } else {
          vm.proposta.prazo_pagamento = vm.proposta.id
            ? vm.proposta.prazo_pagamento_id
            : selected.distribuidor
              ? selected.distribuidor.prazo_pagamento_id
                ? selected.distribuidor.prazo_pagamento_id
                : null
              : null;
        }
      } else {
        vm.proposta.prazo_pagamento = null;
      }

      if (
        selected.distribuidor &&
        selected.distribuidor.grupo_desconto_varejo
      ) {
        vm.proposta.grupo_desconto = selected.distribuidor.grupo_desconto_varejo; // prioridade do grupo do distribuidor
      } else if (selected.grupo_desconto_varejo) {
        vm.proposta.grupo_desconto = selected.grupo_desconto_varejo; // pega grupo do prospecto
      }
      vm.getFaixaDescontos();
      vm.hasDist();
      vm.getProdutos(vm.proposta.tipo_proposta);
      if (!vm.proposta.id) {
        vm.itens = [];
      }
    },
    async buscaLead(key) {
      if (key.length >= 3) {
        const vm = this;
        let params = {
          empresa: key,
          classe_distribuidor: ["V", "F"],
          limit: 10,
          proposta: true,
          tipo: this.proposta.tipo_proposta
        };
        if (
          //this.proposta.tipo_proposta == "BONIFICACAO" ||
          this.proposta.tipo_proposta == "AMOSTRA" ||
          this.proposta.tipo_proposta == 'REQUISICAO'
        ) {
          await axios
            .get("/adm/distribuidores/combo", {
              params: { query: key, classe: "K", tipo: this.proposta.tipo_proposta },
            })
            .then((response) => {
              var found = null
              response.data.forEach((element) => {
                found = vm.prospectos.find((item) => item.id == element.id)
                if (!found) {
                  vm.prospectos.push(element);
                }
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          await axios
            .get("/adm/prospecto/listar", { params: params })
            .then((response) => {
              vm.prospectos = response.data.data;
            }).catch((error) => {
              console.log(error);
            });
        }


      }
    },
    processarCopiaCola() {
      const vm = this;
      var linhas = this.copiaCola.split("\n");
      this.copiaCola = "";

      linhas.forEach((el) => {
        var separador = ";";
        if (el.indexOf(separador) == -1) {
          separador = "\t";
        }
        var linha = el.split(separador);

        if (linha[0]) {
          let npos = vm.listaProdutos.map((x) => x.codigo).indexOf(linha[0]);

          if (npos > -1) {
            let item = {};
            let produto = vm.listaProdutos[npos];
            if (produto.preco_venda > 0) {
              item.produto = produto;
              item.produto_id = produto.id;
              item.valor_unitario = parseFloat(produto.preco_venda);
              item.valor_unitario_tabela = parseFloat(produto.preco_venda);
              item.valor_total = parseFloat(linha[1] * produto.preco_venda);
              item.qtd_caixa = produto.qtd_caixa;
              item.quantidade = linha[1];
              item.preco_regular = produto.preco_regular
              this.addProduto(item);
            }
          }
        }
      });
    },

    resetImportarPlanilha() {
      this.arquivoImportacao = null;
      this.importacaoResultado = null;
    },
    async importarPlanilha() {
      const vm = this;
      if (!this.arquivoImportacao) {
        return;
      }
      this.loadingImportacao = true;
      this.importacaoResultado = null;

      const formData = new FormData();
      formData.append("arquivo", this.arquivoImportacao);

      try {
        const response = await axios.post("/venda-direta/proposta/importar-planilha", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const sucesso = [];
        const erros = [];
        const linhas = response.data.itens || [];

        for (const linha of linhas) {
          const codigo = String(linha.produto || "").trim().toUpperCase();
          const npos = vm.listaProdutos
            .map((x) => String(x.codigo).trim().toUpperCase())
            .indexOf(codigo);

          if (npos === -1) {
            erros.push(`Produto "${linha.produto}" não encontrado.`);
            continue;
          }

          const produto = vm.listaProdutos[npos];
          const quantidade = parseInt(linha.quantidade);
          if (!quantidade || quantidade <= 0) {
            erros.push(`Produto ${produto.codigo}: quantidade inválida.`);
            continue;
          }

          const valorTabela = parseFloat(produto.preco_venda);
          let valorUnitario = valorTabela;
          if (linha.preco !== null && linha.preco !== "" && linha.preco !== undefined) {
            valorUnitario = parseFloat(String(linha.preco).replace(",", "."));
            if (isNaN(valorUnitario)) {
              erros.push(`Produto ${produto.codigo}: preço informado inválido.`);
              continue;
            }
            if (valorUnitario < valorTabela) {
              erros.push(
                `Produto ${produto.codigo}: preço informado (R$ ${valorUnitario.toFixed(2)}) é menor que o de tabela (R$ ${valorTabela.toFixed(2)}).`
              );
              continue;
            }
          }

          await vm.addProduto({
            produto: produto,
            produto_id: produto.id,
            quantidade: quantidade,
            valor_unitario: valorUnitario,
            valor_unitario_tabela: valorTabela,
            valor_total: parseFloat(quantidade * valorUnitario),
            qtd_caixa: produto.qtd_caixa,
            preco_regular: produto.preco_regular,
          });
          sucesso.push(produto.codigo);
        }

        vm.importacaoResultado = { sucesso, erros };
        vm.arquivoImportacao = null;
      } catch (error) {
        const msg =
          (error.response && error.response.data && error.response.data.errors) ||
          "Falha ao importar a planilha.";
        vm.importacaoResultado = { sucesso: [], erros: [msg] };
      } finally {
        vm.loadingImportacao = false;
      }
    },
    async addProduto(_item) {
      const vm = this;
      if (_item.brinde && this.showValorTotalBrinde + 10 < _item.valor_total - (_item.valor_total * this.proposta.desconto) / 100) {
        return this.$swal.fire({
          title: "Atenção",
          text: "O valor do total do brinde não pode ser maior que o saldo brinde!",
          icon: "warning",
        });
      }

      if (!_item.quantidade || _item.quantidade <= 0) {
        return this.$swal.fire({
          title: "Atenção",
          text: "Quantidade inválida",
          icon: "warning",
        });
      }
      // const saldo = await vm.getEstoque(_item.produto_id);
      const saldo = 99999
      let qtd = this.itens.reduce((acc, el) => el.produto_id == _item.produto.id ? acc += parseInt(el.quantidade) : acc, 0) + parseInt(_item.quantidade);
      if (saldo <= 0 || saldo < qtd) {
        if (saldo > 0) {
          vm.makeToast("O produto " + _item.produto.codigo + " tem apenas " + saldo + " unidades disponíveis");
        } else {
          vm.makeToast("O produto " + _item.produto.codigo + " não tem saldo disponível");
        }
        return
      }
      if (saldo && saldo > 0) {
        let existe = this.itens.find((el) => {
          if (el.produto_id === _item.produto_id && _item.brinde == el.brinde) {
            const quantidade = parseInt(parseInt(el.quantidade) + parseInt(_item.quantidade))
            if (saldo < quantidade) {
              vm.makeToast("O produto " + _item.produto.codigo + " tem apenas " + saldo + " unidades disponíveis");
            } else {
              el.quantidade = parseInt(parseInt(el.quantidade) + parseInt(_item.quantidade));
              el.valor_unitario = parseFloat(_item.valor_unitario);
              el.valor_unitario_tabela = parseFloat(_item.valor_unitario_tabela);
              el.valor_total = parseFloat(el.quantidade * (_item.valor_unitario - (_item.valor_unitario * (vm.proposta.desconto / 100))))
            }
            return el.produto_id === _item.produto_id;
          }
        });
        if (!existe) {
          if (saldo < _item.quantidade) {
            vm.makeToast("O produto " + _item.produto.codigo + " tem apenas " + saldo + " unidades disponíveis");
          } else {
            this.itens.push(_item);
          }
        }
        await this.processarPromotions();

        this.item = {
          id: null,
          produto: "",
          quantidade: 1,
          valor_unitario: 0.0,
          valor_total: 0.0,
        };
      } else {
        vm.makeToast("O produto " + _item.produto.codigo + " não tem saldo disponível");
      }
    },
    async getEstoque(item) {
      const vm = this
      vm.loadingEstoque = true
      let saldo = 0
      const params = {
        proposta: this.proposta ? this.proposta.id : null
      }
      await axios.get('/venda-direta/getEstoque/' + item, { params: params })
        .then((response) => {
          const qtdpedido = response.data.produto.qtd_pedido ? parseInt(response.data.produto.qtd_pedido) : 0
          const qtdproposta = response.data.produto.qtd_proposta ? parseInt(response.data.produto.qtd_proposta) : 0
          saldo = response.data.produto.estoque - (qtdpedido + qtdproposta);
        }).catch((error) => {
          console.log(error);
          return null
        }).finally(() => {
          vm.loadingEstoque = false
        })
      return saldo;
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Atenção',
        variant: 'danger',
        solid: true
      })
    },
    imprimir() {
      const vm = this;
      window.open(
        "/venda-direta/proposta/" + this.proposta.id + "/imprimir",
        "_blank"
      );
    },
    buscaProdutoDif() {
      const vm = this;
      if (vm.prospecto.value && vm.prospecto.value.vendedor_id > 0) {
        axios
          .get("/venda-direta/produtos/listaDif/" + vm.prospecto.value.id)
          .then((response) => {
            vm.listaProdutos = [];
            vm.listaProdutos = response.data;
          })
          .catch((erro) => {
            console.log(erro);
          });
      }
    },
    getProdutos(tipo) {
      return new Promise((resolve) => {
        const vm = this;
        vm.listaProdutos = [];
        var data = tipo;
        if (!tipo) {
          data = this.proposta.tipo_proposta;
        }
        axios
          .get("/venda-direta/produtos/lista", { params: { tipo: data , prospecto: vm.proposta.prospecto_id ?? null, classe: vm.proposta.classe ?? null } })
          .then((response) => {
            vm.listaProdutos = response.data;
            // console.log('lista produtos', vm.listaProdutos)
            resolve("Produtos Filtrados");
          })
          .catch((error) => {
            console.log("erro ao listar produtos ...", error);
            resolve("Erro ao listar produtos " + error);
          });
      });
    },    
    hasDist() {
      const cod = this.prospecto.value.distribuidor
        ? this.prospecto.value.distribuidor.codigo
        : null;
      if (
        cod &&
        (cod == "0589030" ||
          cod == "0589031" ||
          cod == "0589032" ||
          cod == "0589029" ||
          cod == "0589028")
      ) {
        this.hasCond90 = true;
      } else {
        this.hasCond90 = false;
      }

      if (cod && cod == "0663609") {
      } else {
        this.hasCont100 = false;
      }
    },
    getPrazos() {
      const vm = this;
      let data = {
        currentPage: 1,
      };

      axios
        .get("/adm/prazo", { params: data })
        .then((response) => {
          vm.optionsPrazo = response.data.map((el) => {
            return {
              value: el.id,
              text: el.descricao,
              media: el.prazo_medio,
            };
          });

          vm.optionsPrazo.push({
            value: null,
            text: "Selecione um Prazo",
            media: 0,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatCurrency(value) {
      if (typeof value !== 'number') {
        return 'R$ 0,00';
      }
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  },
  mounted() {
    axios.get("/my-profile").then(async (response) => {
      this.perfil = response.data.profile;
      this.role = this.perfil.roles[0].label;
      await this.loadProposta();
      // await this.getProdutos();
      this.getPrazos();
    });
  },
};
</script>

<style lang="scss" scoped>
  .total-display h1 {
    font-size: 2.8rem; /* Um pouco menor que o display-4 para não dominar a tela */
    line-height: 1;
  }

  .card-header h5 {
    font-weight: 600;
    color: #495057;
  }

  /* Garante que o fieldset desabilitado fique visualmente claro */
  fieldset:disabled {
    opacity: 0.6;
    pointer-events: none;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/varejo/propostas/create-proposta.vue